/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { IconButton } from '@atlaskit/button/new';
import { cssMap, jsx } from '@atlaskit/css';
import CloseIcon from '@atlaskit/icon/core/migration/close--editor-close';
import { Flex } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

const announcementStyles = cssMap({
	default: {
		paddingTop: token('space.150'),
		paddingBottom: token('space.150'),
		paddingLeft: token('space.150'),
		paddingRight: token('space.150'),
		borderRadius: token('border.radius.100'),
		backgroundColor: token('color.background.discovery'),
		color: token('color.text.discovery'),
	},
});

interface Props {
	text: string;
	onClose: () => void;
}

export function AnnouncementBannerItem({ text, onClose }: Props) {
	return (
		<Flex
			xcss={announcementStyles.default}
			alignItems="center"
			justifyContent="space-between"
			gap="space.050"
		>
			{text}
			<IconButton
				icon={CloseIcon}
				label={'Close'}
				spacing="compact"
				appearance="subtle"
				onClick={onClose}
			/>
		</Flex>
	);
}
